import { render, staticRenderFns } from "./ATagHintPage.vue?vue&type=template&id=2284dcb2&scoped=true"
import script from "./ATagHintPage.vue?vue&type=script&lang=js"
export * from "./ATagHintPage.vue?vue&type=script&lang=js"
import style0 from "./ATagHintPage.vue?vue&type=style&index=0&id=2284dcb2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2284dcb2",
  null
  
)

export default component.exports